<template>
  <nav
    v-for="nav of menu"
    :key="nav._uid"
    role="navigation"
    aria-label="Submenu"
    class="sticky top-0 z-10 flex h-16 border-b border-black/5 bg-gray-200 lg:h-20"
  >
    <div class="container flex items-center px-0 lg:px-6">
      <h2
        v-if="story?.name"
        class="text-primary-500 hidden flex-grow text-lg font-bold lg:block"
      >
        {{ story.name }}
      </h2>
      <ul
        class="no-scrollbar flex h-full items-center gap-4 overflow-auto lg:ml-auto"
        role="menubar"
      >
        <li
          v-for="menuItem of nav.menuItems"
          :key="menuItem._uid"
          class="h-full flex-none first-of-type:ml-6 last-of-type:mr-6 lg:first-of-type:ml-0 lg:last-of-type:mr-0"
          role="none"
        >
          <StoryblokComponent
            :blok="menuItem"
            :class="{
              'border-primary-500 text-gray-900': isCurrentPage(
                menuItem.link?.cached_url,
                story?.full_slug,
              ),
              'border-transparent text-gray-700': !isCurrentPage(
                menuItem.link?.cached_url,
                story?.full_slug,
              ),
            }"
            class="block h-full border-b-2 px-2 text-sm hover:text-gray-900 lg:px-1"
          />
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
import type { BlockNavigationMenuStoryblok } from '@/types/storyblok'
import { isCurrentPage } from '@/utils/link-utils'

defineProps<{
  menu: BlockNavigationMenuStoryblok[]
}>()

const currentStory = useCurrentStoryStore()
const { story } = storeToRefs(currentStory)
</script>
